import { models } from '@kurtosys/ksys-app-template';
import { IAppConfigurationBase } from '../models/app/IAppConfigurationBase';

export const APPLICATION_CLIENT_CONFIGURATIONS: models.api.applicationManager.IApplicationClientConfiguration[] = [
	{
		applicationClientConfigurationId: 1,
		configuration: {
			assetOverrides: {
				base: {
					dropdown: {
						caretDown: 'CaretDown.svg',
						caretUp: 'CaretUp.svg',
					},
					search: {
						cross: 'Cross.svg',
						magnificationGlass: 'MagnificationGlass.svg',
						spinner: 'Spinner.svg',
					},
				},
				baseUrl: 'https://api-rel.fundpress.io/applicationManager/apps/a574a496-59df-4771-be93-e58afea2654e/',
			},
			culture: {
				base: 'Default',
				default: 'en-GB',
			},
			core: {
				inputs: {
					queries: [
						{
							queryId: 'urlPattern',
							queryOptionsType: 'none',
							value: '/:fundId',
						},
						{
							queryId: 'urlFundId',
							queryOptionsType: 'url',
							code: 'param',
							urlPattern: {
								queryOptionsType: 'input',
								key: 'urlPattern',
							},
							key: 'fundId',
						},
					],
				},
				skeletonLoaders: {
					variables: [
						{
							key: 'fillColor',
							value: '#dddddd',
						},
					],
					loaders: [
						{
							id: 'ksys-app-start',
							breakpoints: [
								{
									minWidthInPixels: 0,
									style: {
										height: '86px',
									},
									children: [
										{
											'fill': '{fillColor}',
											'x': '0px',
											'y': '11.90625px',
											'height': '28px',
											'width': '100%',
										},
										{
											'fill': '{fillColor}',
											'x': '0px',
											'y': '59.8125px',
											'height': '18px',
											'width': '100%',
										},
									],
								},
							],
						},
					],
				},
			},
			data: {
				context: {
					entities: [
						{
							id: 'entitiesForCards',
							inputs: [
								{
									key: 'inputFundList',
									query: {
										queryOptionsType: 'input',
										key: 'fundList',
									},
								},
							],
							requestBody: {
								include: {
									commentaries: {},
								},
							},
							requestBodyQueries: {
								search: [
									{
										matchtype: 'MATCH',
										property: {
											queryOptionsType: 'input',
											value: 'fundLists',
										},
										values: {
											queryOptionsType: 'none',
											transforms: [
												{
													splitSeparator: ',',
													transformOptionsType: 'split',
												},
											],
										},
									},
									{
										matchtype: 'MATCH',
										property: {
											queryOptionsType: 'none',
											value: 'fund_code',
										},
										values: {
											code: 'fund_code',
											entityType: 'FUND',
											queryOptionsType: 'property',
											transforms: [
												{
													splitSeparator: ',',
													transformOptionsType: 'split',
												},
											],
										},
									},
								],
							},
						},
						{
							id: 'childEntities',
							inputs: [
								{
									key: 'inputFundList',
									query: {
										queryOptionsType: 'input',
										key: 'fundList',
									},
								},
							],
							requestBody: {
								sort: [
									{
										direction: 'ASC',
										key: 'short_name',
									},
								],
							},
							requestBodyQueries: {
								include: {
									documents: {
										joinSpec: [
											{
												joinFrom: 'isin',
												joinTo: 'isin',
												search: [],
											},
										],
									},
								},
								search: [
									{
										matchtype: 'MATCH',
										property: {
											queryOptionsType: 'none',
											value: 'fund_code',
										},
										values: {
											code: 'fund_code',
											entityType: 'FUND',
											queryOptionsType: 'property',
											transforms: [
												{
													splitSeparator: ',',
													transformOptionsType: 'split',
												},
											],
										},
									},
								],
								type: 'CLSS',
							},
						},
						{
							id: 'dropdown',
							inputs: [
								{
									key: 'fundCode',
									query: {
										code: 'fund_code',
										entityType: 'CLSS',
										queryOptionsType: 'property',
									},
								},
								{
									key: 'fundList',
									query: {
										entityType: 'CLSS',
										queryOptionsType: 'fundLists',
									},
								},
								{
									key: 'inputFundList',
									query: {
										queryOptionsType: 'input',
										key: 'fundList',
									},
								},
							],
							requestBody: {
								identifierSearch: {
									fuzzy: false,
									properties: [
										'fund_code',
									],
									value: '{input:fundCode}',
								},
								fundList: '{input:inputFundList}',
								include: {},
								includeProperties: [
									'share_class_type',
									'distribution_policy_abbreviation',
								],
								preserveOriginal: true,
								search: [],
								sort: {
									direction: 'ASC',
									key: 'share_class_name',
								},
								type: 'CLSS',
							},
						},
					],
					entityByType: {
						CLSS: {
							clientCodeProperty: 'isin',
							include: {},
							inputKey: 'isin',
							searchEntityRequest: {
								applyFormats: true,
							},
						},
						FUND: {
							clientCodeProperty: 'fund_code',
							include: {},
							inputKey: 'fundId',
							searchEntityRequest: {
								type: 'CLSS',
							},
						},
					},
					globalDisclaimers: [
						{
							global: false,
							types: [
								'no_data_disclaimer',
								'performance_disclaimer',
							],
						},
						{
							cultures: [
								'en-GB',
								'de-CH',
								'de-DE',
								'es-ES',
								'fr-CH',
								'fr-FR',
								'it-IT',
								'nl-NL',
							],
							global: true,
							types: [
								'performance_disclaimer',
								'key_risk_warning_disclaimer',
								'aum_tooltip',
								'ongoing_charge_tooltip',
								'srri_tooltip',
								'nav_tooltip',
								'yield_tooltip',
								'no_performance_text',
								'perf_chart_explanatory_text',
								'no_documents',
								'breakdown_by_asset_class',
								'de_nav_disclaimer',
								'cumulative_return',
								'annualised_return',
							],
						},
					],
					globalDocuments: [
						{
							search: [
								{
									matchtype: 'MATCH',
									meta: true,
									property: 'audience',
									values: [
										'{input:audience}',
									],
								},
							],
							type: '',
						},
					],
					globalQueries: [
						{
							code: 'asset_class',
							entityType: 'CLSS',
							queryId: 'assetClass',
							queryOptionsType: 'property',
						},
					],
					performanceCheck: {
						end: {
							code: 'effective_date',
							entityType: 'FUND',
							queryOptionsType: 'property',
						},
						measure: {
							operator: '>=',
							period: 'YEARS',
							value: 1,
						},
						start: {
							code: 'fund_launch_date',
							entityType: 'FUND',
							queryOptionsType: 'property',
						},
						useNowForEndDate: true,
					},
				},
			},
		} as IAppConfigurationBase,
		name: 'root',
		applicationClientConfigurationTypeId: 1,
	},
];
